import React from 'react';
import PropTypes from 'prop-types';
import { ProviderValidate } from '@bagonboard/ui-kit';

// @material-ui/core components
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '../../../../../../../components/CustomButtons/Button';
import CustomInput from '../../../../../../../components/CustomInput/CustomInput';
import { constraints } from '../../constants';

class PassengerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name        : '',
      nameError   : undefined,
      surname     : '',
      surnameError: undefined,
      ticket      : '',
      ticketError : undefined,
    };
  }

  onInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value, [`${name}Error`]: undefined });
  };

  onSubmit = () => {
    const { name, surname, ticket } = this.state;
    const errors = ProviderValidate.validate(
      {
        name,
      },
      constraints,
    );
    if (errors) {
      this.setState({
        nameError: errors.name && errors.name[0],
      });
    } else {
      const {
        id, onClose, paxs, updateService,
      } = this.props;
      const newPaxs = [
        ...paxs.map(item => ({ ...item, _id: undefined })),
        {
          bags        : [],
          name        : name || null,
          numBags     : 0,
          photos      : {},
          seatNumber  : null,
          surname     : surname || null,
          ticketNumber: ticket || null,
        },
      ];

      updateService({ paxs: newPaxs, serviceId: id });
      onClose();
    }
  };

  render() {
    const { onClose, open } = this.props;
    const {
      name, nameError, surname, surnameError, ticket, ticketError,
    } = this.state;

    return (
      <Dialog open={open} onClose={onClose} aria-labelledby="create-passenger-dialog">
        <DialogTitle id="create-passenger-dialog">Create Passenger</DialogTitle>
        <DialogContent>
          <CustomInput
            error={!!nameError}
            helpText={nameError}
            id="name"
            labelText="Name"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              name    : 'name',
              onChange: this.onInputChange,
              value   : name,
            }}
          />
          <CustomInput
            error={!!surnameError}
            helpText={surnameError}
            id="surname"
            labelText="Surname"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              name    : 'surname',
              onChange: this.onInputChange,
              value   : surname,
            }}
          />
          <CustomInput
            error={!!ticketError}
            helpText={ticketError}
            id="ticket"
            labelText="E-Ticket"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              name    : 'ticket',
              onChange: this.onInputChange,
              value   : ticket,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button color="info" onClick={onClose} simple>
            Cancel
          </Button>
          <Button color="info" onClick={this.onSubmit}>
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

PassengerDialog.propTypes = {
  id           : PropTypes.string,
  onClose      : PropTypes.func,
  open         : PropTypes.bool,
  paxs         : PropTypes.arrayOf(PropTypes.shape({})),
  updateService: PropTypes.func,
};

PassengerDialog.defaultProps = {
  id  : null,
  onClose() {},
  open: false,
  paxs: [],
  updateService() {},
};

export default PassengerDialog;
